import { useRef, useState } from 'react';
import { Box, Button } from '@mui/material';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const sampleItems = [
    {
        poNo: '0501/17-18 Dt. 16/03/2018',
        itemCode: '0501040165',
        description: 'BEARING 2025\nMake: AIRMAX\n1236,1234,1235,1237,1238',
        dept: 'MEC',
        uom: 'KG',
        challanQty: 5,
        receivedQty: 5,
        shortQty: 0,
        excessQty: 0,
        rejectedQty: 1,
        acceptedQty: 4,
        rate: 1900,
        discount: 0,
        totalValue: 7600,
    },
    {
        poNo: '0501/17-18 Dt. 16/03/2018',
        itemCode: '0501040166',
        description: 'BEARING 2025\nMake: AIRMAX\n1236,1234,1235,1237,1238',
        dept: 'MEC',
        uom: 'KG',
        challanQty: 5,
        receivedQty: 5,
        shortQty: 0,
        excessQty: 0,
        rejectedQty: 1,
        acceptedQty: 4,
        rate: 1900,
        discount: 0,
        totalValue: 7600,
    },
];



const GoodsReceiptNote = ({ poData }) => {
    const poRef = useRef();
    const grandTotal = poData.receives_table_det.reduce((sum, item) => sum + item.grand_total, 0);
    const [fontSize, setFontSize] = useState(10);

    const handleDownload = async () => {
        const input = poRef.current;

        const canvas = await html2canvas(input, {
            scale: 2,
            useCORS: true,
            backgroundColor: '#fff',
        });

        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('l', 'mm', 'a4'); // Landscape mode

        const pdfWidth = pdf.internal.pageSize.getWidth();   // 297mm
        const pdfHeight = pdf.internal.pageSize.getHeight(); // 210mm

        const imgWidth = pdfWidth;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        let heightLeft = imgHeight;
        let position = 0;

        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pdfHeight;

        while (heightLeft > 0) {
            position -= pdfHeight;
            pdf.addPage();
            pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
            heightLeft -= pdfHeight;
        }

        pdf.save('purchase_received_notes.pdf');
    };

    const verticalOnlyCellStyle = {
        borderLeft: '0.25px solid black',
        borderRight: '0.25px solid black',
        borderTop: 'none',
        borderBottom: 'none',
    };




    return (

        <Box p={2} display="flex"  >
            <Box>
                <Button variant="contained" color='secondary' onClick={handleDownload} sx={{ mb: 2 }}>
                    Download as PDF
                </Button>
                <Box
                    ref={poRef}
                    sx={{
                        width: '297mm',
                        minHeight: '210mm',
                        padding: '5mm',
                        backgroundColor: '#fff',
                        fontSize: `${fontSize}px`,
                        color: '#000',
                        boxSizing: 'border-box',
                    }}
                >


                    <>
                        <div style={{ fontFamily: 'cambria', fontSize: '11px', color: '#000', padding: '20px', width: '100%', boxSizing: 'border-box' }}>
                            <style>{`
                                table {
                                border-collapse: collapse;
                                width: 100%;
                                }
                                td, th {
                                border: 0.25px solid #000;
                                padding: 4px;
                                vertical-align: top;
                                }
                                .no-border td {
                                border: none;
                                padding: 2px;
                                }
                                .section-title {
                                font-weight: bold;
                                text-align: center;
                                font-size: 14px;
                                // text-decoration: underline;
                                }
                                .signatures td {
                                border-top: 0.25px solid black;
                                text-align: center;
                                padding-top: 8px;
                                font-weight: bold;
                                }
                            `}</style>

                            <table className="no-border">
                                <tbody>
                                    <tr style={{ borderTop: '0.25px solid black', borderLeft: '0.25px solid black', borderRight: '0.25px solid black' }}>
                                        <td colSpan="2" style={{ textAlign: 'center' }}>
                                            <div className="section-title">{poData.company[0].company_name}</div>
                                            <div>{poData.company[0].address}, {poData.company[0].city}, {poData.company[0].state}, {poData.company[0].country} - {poData.company[0].pin_code}</div>
                                            <div>GSTIN: {poData.company[0].gst_no}</div>
                                            <div className="section-title">GOODS RECEIPT NOTE</div>
                                        </td>
                                    </tr>
                                    <tr style={{ borderCollapse: 'collapse', border: '0.25px solid black', borderBottom: '0px solid black' }}>
                                        <td style={{ borderCollapse: 'collapse', border: '0.25px solid black', borderBottom: '0px solid black' }}><strong>GRN NO.:</strong> {poData.purchase_received_no}</td>
                                        <td style={{ borderCollapse: 'collapse', border: '0.25px solid black', borderBottom: '0px solid black' }}><strong>GRN DATE:</strong> {poData.purchase_received_date}</td>
                                    </tr>
                                    <tr style={{ borderCollapse: 'collapse', border: '0.25px solid black', borderBottom: '0px solid black' }}>
                                        <td style={{ borderCollapse: 'collapse', border: '0.25px solid black', borderBottom: '0px solid black', width: '70%' }}>
                                            <strong>Supplier:</strong><br />
                                            <div style={{ marginLeft: '40px' }}>
                                                {poData.supplier[0].company_name}<br />
                                                {poData.supplier[0].billing_address}<br />
                                                <strong>State Code:</strong>{poData.supplier[0].billing_state_id} <br />
                                                <strong>GSTIN:</strong> {poData.supplier[0].gst_number} |  <strong>PAN:</strong> {poData.supplier[0].pan_number}
                                            </div>
                                        </td>
                                        <td>
                                            <tr style={{ borderCollapse: 'collapse', borderBottom: '0px solid black', width: '100%' }}>
                                                <td>
                                                    <strong>INVOICE NO.:</strong> {poData.party_invoice_no}<br />
                                                    <strong>D.C NO.:</strong> {poData.do_number}<br />
                                                    <strong>TRANSPORTER:</strong> {poData.transporter}<br />
                                                    <strong>VEHICLE NO.:</strong> {poData.vehicle_number}
                                                </td>
                                                <td>
                                                    <strong>DATE:</strong> {poData.party_invoice_date}<br />
                                                    <strong>DATE:</strong> {poData.do_date}<br />
                                                </td>
                                            </tr>


                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            {/* <br /> */}
                            <table className="no-border"  >
                                <thead>
                                    <tr style={{ borderCollapse: 'collapse', border: '0.25px solid black', }}>
                                        <th>Sl. No</th>
                                        <th>PO No. / Date</th>
                                        <th>Item Code</th>
                                        <th>Item Description</th>
                                        <th>Dept.</th>
                                        <th>UOM</th>
                                        <th>Challan Qty</th>
                                        <th>Received Qty</th>
                                        {/* <th>Short Qty</th>
                                        <th>Excess Qty</th>
                                        <th>Accepted Qty</th> */}
                                        <th>Rate</th>
                                        <th>Discount</th>
                                        <th>CGST</th>
                                        <th>SGST</th>
                                        <th>IGST</th>
                                        <th>TDS</th>
                                        <th>Total Value</th>
                                    </tr>
                                </thead>

                                <tbody >
                                    {poData.receives_table_det.map((item, index) => (
                                        <tr key={index}>
                                            <td style={{ borderLeft: '0.25px solid black', borderRight: '0.25px solid black', textAlign: 'center' }}>{index + 1}</td>
                                            <td style={{ borderLeft: '0.25px solid black', borderRight: '0.25px solid black', padding: '2px' }}>{item.po_no}- {item.po_date}</td>
                                            <td style={{ borderLeft: '0.25px solid black', borderRight: '0.25px solid black',padding:'2px' }}>{item.item_code}</td>
                                            <td style={{ borderLeft: '0.25px solid black', borderRight: '0.25px solid black',padding:'2px' }}>{item.description}</td>
                                            <td style={{ borderLeft: '0.25px solid black', borderRight: '0.25px solid black',padding:'2px' }}>{item.dept}</td>
                                            <td style={{ borderLeft: '0.25px solid black', borderRight: '0.25px solid black',padding:'2px', textAlign: 'center' }}>{item.uom}</td>
                                            <td style={{ borderLeft: '0.25px solid black', borderRight: '0.25px solid black', textAlign: 'right',padding:'2px' }}>{item.challan_qty.toFixed(2)}</td>
                                            <td style={{ borderLeft: '0.25px solid black', borderRight: '0.25px solid black', textAlign: 'right',padding:'2px' }}>{item.received_qty.toFixed(2)}</td>
                                            {/* <td style={{ borderLeft: '0.25px solid black', borderRight: '0.25px solid black', textAlign: 'right',padding:'2px' }}>{item.short_qty.toFixed(2)}</td>
                                            <td style={{ borderLeft: '0.25px solid black', borderRight: '0.25px solid black', textAlign: 'right',padding:'2px' }}>{item.excess_qty.toFixed(2)}</td>
                                            <td style={{ borderLeft: '0.25px solid black', borderRight: '0.25px solid black', textAlign: 'right',padding:'2px' }}>{item.accepted_qty.toFixed(2)}</td> */}
                                            <td style={{ borderLeft: '0.25px solid black', borderRight: '0.25px solid black', textAlign: 'right',padding:'2px' }}>{item.rate.toFixed(2)}</td>
                                            <td style={{ borderLeft: '0.25px solid black', borderRight: '0.25px solid black', textAlign: 'right',padding:'2px'}}>{item.discount_value.toFixed(2)}</td>
                                            <td style={{ borderLeft: '0.25px solid black', borderRight: '0.25px solid black', textAlign: 'right',padding:'2px'}}>{item.cgst_value.toFixed(2)}</td>
                                            <td style={{ borderLeft: '0.25px solid black', borderRight: '0.25px solid black', textAlign: 'right',padding:'2px'}}>{item.sgst_value.toFixed(2)}</td>
                                            <td style={{ borderLeft: '0.25px solid black', borderRight: '0.25px solid black', textAlign: 'right',padding:'2px'}}>{item.igst_value.toFixed(2)}</td>
                                            <td style={{ borderLeft: '0.25px solid black', borderRight: '0.25px solid black', textAlign: 'right',padding:'2px' }}>{item.tds_value.toFixed(2)}</td>
                                            <td style={{ borderLeft: '0.25px solid black', borderRight: '0.25px solid black', textAlign: 'right',padding:'2px' }}>{item.grand_total.toFixed(2)}</td>
                                        </tr>
                                    ))}

                                    {/* Add empty rows to fill space if less than 10 items */}
                                    {Array.from({ length: Math.max(0, 10 - poData.receives_table_det.length) }).map((_, idx) => (
                                        <tr key={`empty-${idx}`} style={{ height: '25px' }}>
                                            {Array.from({ length: 15 }).map((_, colIdx) => (
                                                <td key={colIdx} style={{ ...verticalOnlyCellStyle }}></td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>


                            </table>

                            {/* <br /> */}
                            <table className="no-border" >
                                <tbody>
                                    <tr style={{ borderTop: '0.25px solid black', borderBottom: '0.25px solid black', borderLeft: '0.25px solid black', borderRight: '0.25px solid black' }}>
                                        <td style={{ width: '70%' }}></td>
                                        <td style={{ textAlign: 'right' }} ><strong>Grand Total:</strong> ₹{grandTotal.toFixed(2)}</td>
                                    </tr>
                                    <tr style={{ borderBottom: 'none', borderLeft: '0.25px solid black', borderRight: '0.25px solid black' }}>
                                        <td><strong>Authorized:</strong> Yes</td>
                                        <td><strong>Inspection Required:</strong> Yes</td>

                                    </tr>
                                </tbody>
                            </table>

                            {/* <br /><br /> */}
                            <table>
                                <tbody>
                                    <tr style={{ borderBottom: '0.25px solid black', borderLeft: '0.25px solid black', borderRight: '0.25px solid black', borderTop: 'none' }}>
                                        <td style={{ paddingTop: '40px', textAlign: 'center' }}>EDP PREPARED BY</td>
                                        <td style={{ paddingTop: '40px', textAlign: 'center' }}>STORE MANAGER</td>
                                        <td style={{ paddingTop: '40px', textAlign: 'center' }}>INSPECTED BY</td>
                                        <td style={{ paddingTop: '40px', textAlign: 'center' }}>H.O.D.</td>
                                        <td style={{ paddingTop: '40px', textAlign: 'center' }}>ACCOUNT MANAGER</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </>

                </Box>
            </Box>
        </Box>
    );
};

export default GoodsReceiptNote;
